$.widget('sensibio.navigation', {
	options: {
		selectors: {
			navigation: '#navigation',
			item: '[data-role=navigation-item]',
			header: '[data-role=header]',
		},
		classes: {
			visible: '_visible',
			nearFooter: '_near-footer',
			active: 'active',
		},
		scrollOffset: 100,
		footerOffset: 200,
		scrollOffsetTop: 80,
	},

	_create() {
		this._bind();
	},

	_bind() {
		this._cache();
		this._events();
	},

	_cache() {
		const { selectors } = this.options;

		this.$navigation = $(selectors.navigation);
		this.$footer = $('.footer');
		this.$items = this.$navigation.find(selectors.item);
		this.$header = $(selectors.header);
	},

	_events() {
		if (!this.$navigation.length) return;

		let ticking = false;

		const onScroll = () => {
			if (ticking) return;

			ticking = true;

			requestAnimationFrame(() => {
				this._handleScroll();
				ticking = false;
			});
		};

		this._handleScroll();
		this._bindClicks();
		$(window).on('scroll.navigation', onScroll);

		this._on(this.element, {
			remove: () => {
				$(window).off('scroll.navigation', onScroll);
			},
		});
	},

	_handleScroll() {
		const { classes, scrollOffset, footerOffset, scrollOffsetTop } = this.options;

		const scrollY = window.scrollY || window.pageYOffset;
		const windowHeight = window.innerHeight;
		const documentHeight = document.documentElement.scrollHeight;
		const windowWidth = window.innerWidth;

		const isScrolled = scrollY > scrollOffset;

		// считаем «доскролл до футера» от верхней границы футера
		let isNearFooter = false;
		if (this.$footer && this.$footer.length) {
			const footerTop = this.$footer.offset().top;
			// как только нижний край вьюпорта достигает футера — скрываем навигацию
			isNearFooter = scrollY + windowHeight >= footerTop;
		} else {
			isNearFooter = scrollY + windowHeight > documentHeight - footerOffset;
		}

		if (isScrolled && !isNearFooter) {
			this.$navigation
				.addClass(classes.visible)
				.removeClass(classes.nearFooter)
				.show();

			// прибиваем к низу экрана только на десктопе
			if (windowWidth >= 1025) {
				const navHeight = this.$navigation.outerHeight();
				const offset = 24; // отступ от низа
				const top = windowHeight - navHeight - offset;

				this.$navigation.css({
					top,
					bottom: 'auto',
				});
			} else {
				this.$navigation.css({
					top: '',
					bottom: '',
				});
			}
		} else if (isNearFooter) {
			this.$navigation
				.removeClass(classes.visible)
				.addClass(classes.nearFooter)
				.hide();

			// возвращаем из инлайнов, чтобы не мешать футеру
			this.$navigation.css({
				top: '',
				bottom: '',
			});
		} else {
			this.$navigation
				.removeClass(classes.visible)
				.removeClass(classes.nearFooter)
				.show();

			// начальное положение — только из CSS
			this.$navigation.css({
				top: '',
				bottom: '',
			});
		}

		if (this.$header && this.$header.length) {
			this.$header.toggleClass('scrolled', scrollY > 0);
		}

		// scrollspy: подсветка текущей секции
		if (this.$items && this.$items.length) {
			let currentId = null;

			this.$items.each((_, el) => {
				const $item = $(el);
				const targetSelector = $item.data('target');
				if (!targetSelector) return;

				const $target = $(targetSelector);
				if (!$target.length) return;

				const top = $target.offset().top - scrollOffsetTop - 1;
				if (scrollY >= top) {
					currentId = $item.data('id');
				}
			});

			if (currentId !== null) {
				this.$items.each((_, el) => {
					const $item = $(el);
					const isActive = String($item.data('id')) === String(currentId);
					$item.toggleClass(classes.active, isActive);
				});
			}
		}
	},

	_bindClicks() {
		const { classes, scrollOffsetTop } = this.options;

		if (!this.$items || !this.$items.length) return;

		this.$items.on('click', (event) => {
			const $item = $(event.currentTarget);
			const targetSelector = $item.data('target');
			const hash = $item.data('hash');

			if (!targetSelector) return;

			const $target = $(targetSelector);
			if (!$target.length) return;

			event.preventDefault();

			const targetTop = $target.offset().top - scrollOffsetTop;

			this.$items.removeClass(classes.active);
			$item.addClass(classes.active);

			if (hash || targetSelector) {
				window.history.pushState(null, '', hash || targetSelector);
			}

			window.scrollTo({
				top: targetTop,
				behavior: 'smooth',
			});
		});
	},
});

